import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const FoodPage = () => (
  <Layout>
      <div class="container col-8">
    <SEO title="Pembuatan website toko jajan makanan oleh oleh" />
    <h1><strong><a href="/food" class="text-primary" title="jasa pembuatan website toko jajan makanan oleh oleh">FOOD SHOP</a></strong></h1><hr/>
    <p>Website sangat penting untuk pengusaha toko jajan oleh oleh dan makanan kemasan dalam kebutuhan perkenalan kepada pelanggan secara luas baik dari dalam maupun seluruh dunia dengan sebuah <a href="/food" class="text-primary" title="jasa pembuatan website toko jajan makanan oleh oleh">pembuatan website food</a>.</p>
    <div class="embed-responsive embed-responsive-21by9 rounded">
    <iframe title="pembuatan website restoran rumah makan cafe" width="560" height="315" src="https://www.youtube.com/embed/guHJc2wEdJ4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
<p>Menggunakan desain landing page semakin memudahkan pelanggan dalam memperoleh informasi mengenai food produk yang dijual plus keterangan detail nya, dan membantu dalam pemasaran mu via online website ini, interaksi dengan pelanggan via online memudahkan untuk memperkenalkan secara luas produk menu makanan toko jajan, dukungan desain mewah dan elegan disertai foto produk dan video promosi semakin menarik pelanggan dalam minat membeli.</p>
   <p>Segera buat website kamu sekarang untuk masa depan lebih baik dalam kemajuan bisnis mu.</p>
    <Link class="btn btn-lg btn-primary rounded-pill p-3 md-5" to="/price">Price list</Link>
    <Link class="btn btn-lg btn-primary rounded-pill p-3 md-5" to="/">Home Page</Link>
    <br/><br/>
    </div>
  </Layout>
)

export default FoodPage
